import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {CommonSvgIconsComponent} from "../../../../shared/components/common-svg-icons/common-svg-icons.component";
import {CurrencyPipe, NgForOf, NgIf} from "@angular/common";
import {TagInputModule} from "ngx-chips";
import {GeneralService} from "../../../../core/services/general.service";
import {FundingService} from "../../../../core/services/funding.service";
import {DropzoneComponent, DropzoneConfigInterface, DropzoneModule} from 'ngx-dropzone-wrapper';
import {ConfirmComponent} from "../../../../shared/components/generalModals/confirm/confirm.component";

import {environment} from "../../../../../environments/environment";
import {EventsEvidenceFilesComponent} from "../../event/events-evidence-files/events-evidence-files.component";
const END_POINT = `${environment.SERVICES_URL}`;
const API_KEY = `${environment.API_KEY}`;

@Component({
  selector: 'app-funding',
  standalone: true,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonSvgIconsComponent,
        CurrencyPipe,
        NgForOf,
        NgIf,
        TagInputModule,
        DropzoneModule
    ],
  templateUrl: './funding.component.html',
  styleUrl: './funding.component.scss'
})
export class FundingComponent implements OnInit{
    @Input() confirmAction!: (data: any) => void;
    @Input() data: any;
    listFunding: any[] = [];
    totalFunding: number = 0;
    listEvent: any[] = [];
    openNew = false;
    isOpen = false;
    textDropzone = '<i class="icon-cloud-up"></i>';
    @ViewChild(DropzoneComponent, { static: false }) dropzone?: DropzoneComponent;

    public config: DropzoneConfigInterface = {
        clickable: true,
        addRemoveLinks: true,
        dictRemoveFile: 'Eliminar archivo',
        url: `${END_POINT}/funding/upimages`,
        method: 'post',
        maxFilesize: 5,
        acceptedFiles: 'image/*,application/pdf',
        paramName: 'file',
        headers: {
            'X-Api-Key': `${API_KEY}`,
        }
    };
    evidencesUploaded: string[] = [];
    public fundingForm: FormGroup;
    constructor(public modalFunding:NgbModal, private fb: FormBuilder, private generalService: GeneralService, private fundingService: FundingService) {
        this.fundingForm= this.fb.group({
            id: [""],
            assignment: ["", Validators.required],
            amount: ["", Validators.required],
            comment: ["", Validators.required],
            event: [""],
            evidence: [],
            evidenceDelete: [],
        });
    }

    ngOnInit(): void {
        this.fundingForm.patchValue({
            assignment: this.data['assignments.id']
        });
        //Cargar fondeos
        this.getData();
        //Cargar eventos
        this.getEvents();
    }

    // Función para obtener los fondeos del servicio
    getData() {
        this.fundingService.getFunding({assignment: this.data['assignments.id']}).subscribe(
            (res: any) => {
                if (res.error) {
                    this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
                } else {
                    this.listFunding = res.message?.rows;
                    this.totalFunding = res.message?.totalAmount;
                }
            },
            (err: any) => {
                this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
            }
        );
    }

    //Función para obtener los eventos del servicio
    getEvents() {
        this.fundingService.getEvents({service: this.data['service.id']}).subscribe(
            (res: any) => {
                if (res.error) {
                    this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
                } else {
                    this.listEvent = res.message;
                }
            },
            (err: any) => {
                this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
            }
        );
    }

    //Función para cancelar nuevo registro
    cancelForm(): void {
        this.fundingForm.reset();
        this.fundingForm.patchValue({
            assignment: this.data['assignments.id']
        })
        this.openNew = false;
    }

    submitForm(): void {
        if (this.fundingForm.valid) {
            // Actualiza el form con el nuevo array
            this.fundingForm.patchValue({
                evidence: this.evidencesUploaded
            });
            // Delete
            this.fundingForm.patchValue({
                evidenceDelete: this.evidencesDelete
            })
            const formData = new FormData();
            Object.keys(this.fundingForm.value).forEach(key => {
                formData.append(key, this.fundingForm.value[key]);
            });

            this.fundingService.add(this.fundingForm.value).subscribe(
                (res: any) => {
                    if (res.error) {
                        this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
                    } else {
                        this.generalService.showMessage('success', res.message);
                        this.cancelForm();
                        this.getData();
                    }
                },
                (err: any) => {
                    this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
                }
            );
        } else {
            this.fundingForm.markAllAsTouched();
            this.generalService.showMessage('warn', 'LLene toda la información solicitada');
        }
    }

    onUploadError(args: any): void {
        console.log('warn', args);
    }

    onUploadSuccess(event: any): void {
        let file = event[0];
        let response = event[1]; // Aquí viene el `response`

        if (response.success) {
            event.serverFileName = response.name;
            this.evidencesUploaded.push(response.url);
        }
    }
    evidencesDelete: string[] = [];
    onRemoveSuccess(file: any): void {
        const nombreArchivo = file.serverFileName; // Un campo extra que vamos a poner al subir
        this.evidencesDelete.push(nombreArchivo);
        const index = this.evidencesUploaded.findIndex(url => url.includes(nombreArchivo));
        // Si lo encuentra, lo remueve
        if (index > -1) {
            this.evidencesUploaded.splice(index, 1);
        }
    }

    isNewRecord = true;
    edit(item: any): void {
        item.isShow =!item.isShow;
        this.isNewRecord = false;
        this.fundingForm.patchValue({
            id: item.id,
            assignment: item.assignment_id,
            amount: item.amount,
            comment: item.comments,
            event: item.event_id,
            //evidence: item.evidence
        });

        this.openNew = true;
        // Añadirlo al Dropzone manualmente
        let evidenceList = item.evidence_urls
            ? item.evidence_urls.split(',').map((e: string) => e.trim()).filter((e: any) => !!e)
            : [];

        this.evidencesUploaded = evidenceList;
        this.fundingForm.patchValue({
            evidence: evidenceList
        });
        this.evidencesDelete = [];
        this.fundingForm.patchValue({
            evidenceDelete: this.evidencesDelete
        });

        // Esperar a que Dropzone esté montado (en caso de estar oculto antes)
        setTimeout(() => {
            const dropzoneEvidenceList = this.fundingForm.value.evidence;

            if (this.dropzoneInstance && dropzoneEvidenceList.length) {
                this.dropzoneInstance.removeAllFiles(true);

                dropzoneEvidenceList.forEach((url: string) => {
                    const filename = this.getFileNameFromUrl(url);
                    const mockFile = {
                        name: filename,
                        size: 123456,
                        accepted: true,
                        serverFileName: filename
                    };

                    this.dropzoneInstance.emit("addedfile", mockFile);

                    const isImage = url.match(/\.(jpeg|jpg|png|gif)$/i);
                    if (isImage) {
                        this.dropzoneInstance.emit("thumbnail", mockFile, url);
                    } else {
                        this.dropzoneInstance.emit("thumbnail", mockFile, "assets/pdf-icon.png");
                    }

                    this.dropzoneInstance.emit("complete", mockFile);
                });
            }
        }, 300);
    }

    dropzoneInstance: any; // Esto será la instancia real de Dropzone

    onDropzoneInit(dropzone: any): void {
        this.dropzoneInstance = dropzone;
    }

    getFileNameFromUrl(url: string): string {
        return url.substring(url.lastIndexOf('/') + 1);
    }

    delete(item: any): void {
        item.isShow =!item.isShow;
        let modal = this.modalFunding.open(ConfirmComponent, { centered: true });
        modal.componentInstance.image = "assets/images/gif/danger.gif";
        modal.componentInstance.title = "¿Estás seguro de que deseas eliminar este registro?";
        modal.componentInstance.description = "Esta acción no se puede deshacer. ¿Deseas continuar con la eliminación?";
        modal.componentInstance.refModel = modal;
        modal.componentInstance.confirmAction = () => {
            this.fundingService.delete({id: item.id}).subscribe(
                (res: any) => {
                    if (res.error) {
                        this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
                    } else {
                        this.generalService.showMessage('success', res.message);
                        modal.close();
                        this.getData();
                    }
                },
                (err: any) => {
                    this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
                }
            );
        };
    }
    /**
     * Function: Abrir modal para visualizar los archivos de evidencia
     */
    getEvidenceFiles(row: any){
        if(row.evidence_urls && row.evidence_urls.split(',').length > 0) {
            let modal = this.modalFunding.open(EventsEvidenceFilesComponent, { centered: true, size:'xl' });
            modal.componentInstance.list = row.evidence_urls;
            modal.componentInstance.close = () => {
                modal.close();
            }
        } else {
            this.generalService.showMessage('warn', 'No hay evidencias disponibles para mostrar.');
        }
    }
}
